module.exports = __webpack_public_path__ + "img/explanation.92e35eaa.png";